import { UserOrganizationDTO } from '@/types';
import { apiService } from './api';

export function normalizeUserRole(role?: string | null): string | null {
    const normalizedRole = role?.trim().toLowerCase();
    return normalizedRole || null;
}

export function resolveOrganizationRole(
    organizations: UserOrganizationDTO[],
    selectedOrgId?: string | null
): string | null {
    if (selectedOrgId) {
        const matchingOrganization = organizations.find(
            (organization) => organization.organization_id === selectedOrgId
        );

        if (matchingOrganization) {
            return normalizeUserRole(matchingOrganization.role);
        }
    }

    if (organizations.length === 1) {
        return normalizeUserRole(organizations[0].role);
    }

    return null;
}

export async function fetchCurrentUserRole(selectedOrgId?: string | null): Promise<string | null> {
    const organizations = await apiService.getMyOrganizations();
    return resolveOrganizationRole(organizations, selectedOrgId ?? apiService.getOrgId());
}

export function formatRole(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}
